import { ChronoUnit, LocalDate } from '@js-joda/core';

import { AdditionalEntitlement } from '@dreryk/egabinet-prescription-frontend-api';

const MONTH_IN_DAYS = 30;

export const medicinePrescribedForMoreThanMonth = (startDate: LocalDate, endDate: LocalDate): boolean => {
   return ChronoUnit.DAYS.between(startDate, endDate) > MONTH_IN_DAYS;
};

export const hasOnlyINEntitlement = (entitlements: AdditionalEntitlement[]): boolean =>
   entitlements.length === 1 && entitlements[0].additionalEntitlementType === 'IN';
